import React from 'react';
import FileViewer from 'react-file-viewer';
import { CustomErrorComponent } from 'custom-error';

export default class Preview extends React.Component {
  constructor(props){
      super(props);

      this.state = {
          numPages: null,
          pageNumber: 1,
      }

      this.onPdfLoadSuccess = this.onPdfLoadSuccess.bind(this);
  }

  onPdfLoadSuccess(numPages){
      this.setState({numPages});
  }
  
  render() {
      if(!(['png','jpeg','bmp','docx','xlsx','pdf','csv'].indexOf(this.props.fileType) > -1)){
          return '';
      }else{
          return (
                <FileViewer fileType={this.props.fileType} filePath={this.props.filePath} errorComponent={CustomErrorComponent} onError={e => alert('error')}/>
        );
      }
    
  }
}